import React from 'react';

export default function PersonalInfo({ userFullName,userPersonal,setUserPersonal}) {
  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;
    if (name === "licenseNumber") {
      setUserPersonal({...userPersonal,[name]: value});
    } else if (name === "userStartDay") {
      setUserPersonal({...userPersonal,[name]: value});
    } else if (name === "phoneNumberOffice") {
      setUserPersonal({...userPersonal,[name]: value});
    }  else if (name === "phoneNumberCell") {
      setUserPersonal({...userPersonal,[name]: value});
    }  else if (name === "officeAddress") {
      setUserPersonal({...userPersonal,[name]: value});
    }   
  }
  return (
    <div>
    <div className="header-and-save">
    <h3>פרטים אישיים</h3>
    </div>
      <div className="update-page-personal">
        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="FullName">
              :שם מלא
          </label>
          <input
            className="profile-update-input"
            value = {userFullName}
            name="FullName"
            disabled
          />
        </div> 

        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="licenseNumber">
              :מספר רישיון
          </label>
          <input
            className="profile-update-input"
            type="text"
            name="licenseNumber"
            value = {userPersonal.licenseNumber }
            onChange={event => onChangeHandler(event)}
          />
        </div>

        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="userStartDay">
              :מועד הסמכה בלשכה
          </label>
          <input
          className="profile-update-input"
          type="date"  
          name="userStartDay" 
          value = {userPersonal.userStartDay}
          onChange={event => onChangeHandler(event)}
          />
        </div>

        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="phoneNumberOffice">
              :מספר הטלפון במשרד
          </label>
          <input
          className="profile-update-input"
          type="tel"  
          name="phoneNumberOffice" 
          value = {userPersonal.phoneNumberOffice}
          pattern="[0-9]{2}[0-9]{7}" required
          onChange={event => onChangeHandler(event)}
          />
        </div>

        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="phoneNumberCell">
              :מספר טלפון סלולרי
          </label>
          <input
          className="profile-update-input"
          type="tel"  
          name="phoneNumberCell" 
          value = {userPersonal.phoneNumberCell}
          pattern="[0-9]{3}[0-9]{7}" required
          onChange={event => onChangeHandler(event)}
          />
        </div>

        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="officeAddress">
              :כתובת המשרד
          </label>
          <input
          className="profile-update-input"
          type="text"  
          name="officeAddress" 
          value = {userPersonal.officeAddress}
          onChange={event => onChangeHandler(event)}
          />
        </div>
      </div>
    </div>
  );
}